import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { ValidationService } from '../../../shared/providers/validation.service';
import { PropertyListingService } from '../../../shared/providers/property-listing.service';
import { LoaderService } from '../../../shared/providers/loader.service';
import { ToastService } from '../../../shared/providers/toast.service';
import { FileUploadService } from '../../../shared/providers/fileupload.service';
import { IFileUpload, IPropertyFileUpload } from '../../../shared/models/fileupload';
import { Router } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { INoteInput } from '../../../shared/models/NotesInputModel';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { AuthService } from '../../../shared/auth/auth.service';

@Component({
    selector: 'app-deal-calandar',
    templateUrl: './deal-calandar.component.html',
    styleUrls: ['./deal-calandar.component.css']
})
export class DealCalandarComponent implements OnInit {

    constructor(private Authentication: AuthenticationService, public Validation: ValidationService, private router: Router, private propertyListingService: PropertyListingService,
      private Loader: LoaderService, private modalService: BsModalService, private Toast: ToastService,private _auth0: AuthService, private FileUpload: FileUploadService) {

    }
  @Input() sellerId = 0;
  @Input() properties: any;
  @Input() isFromPrincipalDashboard = false;
  uploadedFiles: IPropertyFileUpload[] = [];
  haveaccesstoviewlocation: boolean = true;
  fileTypes = '.PDF, .XLSX, .XLS, .DOCX, .DOC, .TXT, .DWG'
    calendarData: any;
    showDealsCalendar = false;
    user: any;
    ngOnInit() {
      this.user = this.Authentication.user;
      if (!this.Authentication.Admin() && !this.Authentication.SuperAdmin() && !this.Authentication.Broker() && !this.Authentication.DataEntryStaff()) {
        this.haveaccesstoviewlocation = false;
      }
      else {
        this.haveaccesstoviewlocation = true;
      }
        this.propertyListingService.GetDealCalendar(this.sellerId, this.user.Id).subscribe(res => {
            this.calendarData = res;
            this.showDealsCalendar = true;
        });
    }

    modalRefNotes: BsModalRef;
    isSubmit = false;
    NotesInput = {} as INoteInput;
    openModalForNotes(template: TemplateRef<any>, classes, LeadDetailId, LeadCheckListId, associatedStatusName) {
        this.isSubmit = false;
        this.NotesInput.Id = 0;
        this.NotesInput.Description = '';
        this.NotesInput.UserId = this.user.Id;
        this.NotesInput.ObjectId = LeadDetailId;
        this.NotesInput.AssociatedStatusName = associatedStatusName;
        this.NotesInput.LeadChecklistId = LeadCheckListId;
        this.NotesInput.ObjectTypeId = 303;
        this.modalRefNotes = this.modalService.show(template, { class: classes });
    }

    filesCollection = [];
    categoryList = [];
    errorMessage: string;

    showRemoveButton: boolean = false;
    errorMessageForDocs: string;
    selectedFiles: string[] = [];
    selectedFilesForDocs: string[] = [];
    inputFileUpload = {} as IFileUpload;
    clearFiles: number = 0;
    fileExtensionType = 'document'
    fileUploadType = 'multiple';
    selectedFilesListEmitter(selectedFilesListEmitter: string[]) {
        this.errorMessage = null;
        this.selectedFiles = selectedFilesListEmitter;
        this.clearFiles++; //this.filesCollection = [];
      this.selectedFiles.forEach(item => {
            const fileObj =
            {
                name: item["name"],
                propertyId: 0,
                file: item
            }
            this.filesCollection.push(fileObj);
        });
    }

    removeImage(fileIndex: number, event: any) {
        if (fileIndex > -1) {
            //this.selectedFiles.splice(fileIndex, 1);
            this.filesCollection.splice(fileIndex, 1);
        }
    }

    onFilesClear() {
        this.clearFiles++;
        this.selectedFiles = [];
        this.filesCollection = [];
  }

  fileChange(file1, item) {
    file1.propertyId = parseInt(item.value);
  }

    uploadFiles() {
        this.Loader.display(true);
      let valid = true;
        for (let i = 0; i < this.filesCollection.length; i++) {
            if (parseInt(this.filesCollection[i]["propertyId"]) === 0) {
              this.Toast.addToast({ title: 'Error Occurred', msg: "Please Select Property", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
                this.Loader.display(false);
                valid = false;
                break;
            }
        }
        if (valid) {
            let uploadCount = 1;
            this.filesCollection.forEach(item => {
                //this.inputFileUpload.documentName = item["name"];
                //this.inputFileUpload.fileCategoryId = 414; //other
                //this.inputFileUpload.id = 0;
                //this.inputFileUpload.objectId = item["propertyId"];
                //this.inputFileUpload.objectTypeId = 302;
                //this.inputFileUpload.type = "Documents";

                //let fileToUpload = [];
                //fileToUpload.push(item["file"]);
                //this.FileUpload.uploadFiles(this.inputFileUpload, fileToUpload).subscribe(res => {
                //    if (res != null) {
                //        if (uploadCount == this.filesCollection.length) {
                //            this.onFilesClear();
                //            this.Loader.display(false);
                //            this.Toast.addToast({ title: 'Success', msg: "Files Uploaded Successfully", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
                //        }
                //        uploadCount++;
                //    }
                //});

              let fileToUpload = [];
              fileToUpload.push(item["file"]);
              this.uploadedFiles.push({
                id: 0,
                objectId: item["propertyId"],
                type: 'Documents',
                documentName: item["name"],
                fileCategoryId: 414,
                objectTypeId: 302,
                FileContent: null,
                isDefault: false,
                ImageGuid: this.newGuid(),
                PropertyGuid: '',
                ImageStatus: '',
                fileToUpload: fileToUpload,
                sourceUrl: this.router.url,
              });
            });
          this.clearFiles++;
          if (this.uploadedFiles != null) {
            this.onFilesClear();
            this.Loader.display(false);
            this.imageupload();
            this.Toast.addToast({ title: '', msg: "File uploads are in progress, please don't reload or close the website until complete.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'info' });
          }
        }
  }
  imageupload() {
    this._auth0.FileUpload(this.uploadedFiles);
    this.uploadedFiles = [];
  }
  newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  gotoOfferDetails(LeadGuid) {
    if (this.isFromPrincipalDashboard) {
      this.router.navigateByUrl('/offer-detail/' + LeadGuid + '?prevroute=Principal Dashboard&link=' + this.router.url + '&opentab=tasks');
    }
    else {
      this.router.navigateByUrl('/offer-detail/' + LeadGuid + '?prevroute=Seller Dashboard&link=' + this.router.url + '&opentab=tasks');
    }
    }
}
